module.exports = __webpack_public_path__ + "user-solid.svg?d06b7026b56785c10266b6c328a67660";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-solid.svg
// module id = 809
// module chunks = 0